function toggleWishlist(btn) {
  if (btn.closest('form')) {
    btn.closest('form').addEventListener('submit', e => e.preventDefault());
  }
  
  const id = String(btn.dataset.productId || '');
  const variantId = btn.dataset.variantId || '';
  const title = btn.dataset.productTitle || '';
  const image = btn.dataset.productImage || '';
  const url = btn.dataset.productUrl || '';
  const price = btn.dataset.productPrice || '';
  const comparePrice = btn.dataset.productComparePrice || '';
  const available = btn.dataset.productAvailable !== 'false';
  
  let items = JSON.parse(localStorage.getItem('bazila_wishlist') || '[]');
  const index = items.findIndex(p => String(p.id) === id);
  const icon = btn.querySelector('.wishlist-icon');
  
  if (index === -1) {
    items.push({ id, variantId, title, image, url, price, comparePrice, available });
    document.querySelectorAll(`.wishlist-btn[data-product-id="${id}"]`).forEach(b => {
      const ic = b.querySelector('.wishlist-icon');
      if (ic) ic.textContent = '♥';
      b.classList.add('wishlisted', 'pulse');
      setTimeout(() => b.classList.remove('pulse'), 400);
    });
  } else {
    items.splice(index, 1);
    document.querySelectorAll(`.wishlist-btn[data-product-id="${id}"]`).forEach(b => {
      const ic = b.querySelector('.wishlist-icon');
      if (ic) ic.textContent = '♡';
      b.classList.remove('wishlisted');
    });
  }
  
  localStorage.setItem('bazila_wishlist', JSON.stringify(items));
  updateWishlistHeaderCount();
}

function updateWishlistHeaderCount() {
  const items = JSON.parse(localStorage.getItem('bazila_wishlist') || '[]');
  const count = items.length;

  const countEls = document.querySelectorAll('#header-wishlist-count, #header-mobile-wishlist-count, .wishlist-count');
  countEls.forEach(countEl => {
    if (count > 0) {
      countEl.textContent = count;
      countEl.style.display = 'flex';
      if (countEl.id === 'header-mobile-wishlist-count' || countEl.closest('.header-mobile__wishlist')) {
        countEl.style.setProperty('background', '#1ac6ca', 'important');
        countEl.style.setProperty('background-color', '#1ac6ca', 'important');
        countEl.style.setProperty('color', '#000000', 'important');
      } else {
        countEl.style.setProperty('background', '#e53935', 'important');
        countEl.style.setProperty('background-color', '#e53935', 'important');
        countEl.style.setProperty('color', '#ffffff', 'important');
      }
    } else {
      countEl.textContent = '';
      countEl.style.setProperty('display', 'none', 'important');
    }
  });

  const drawerCountEls = document.querySelectorAll('#header-mobile-drawer-wishlist-count, .wishlist-drawer-count');
  drawerCountEls.forEach(el => {
    if (count > 0) {
      if (el.classList.contains('cart-drawer__wishlist-badge')) {
        el.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;
      } else {
        el.textContent = `(${count})`;
      }
      el.style.display = 'inline-block';
    } else {
      el.textContent = '';
      el.style.display = 'none';
    }
  });
}

// On page load
document.addEventListener('DOMContentLoaded', function() {
  const items = JSON.parse(localStorage.getItem('bazila_wishlist') || '[]');
  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    const id = String(btn.dataset.productId || '');
    if (items.some(p => String(p.id) === id)) {
      const icon = btn.querySelector('.wishlist-icon');
      if (icon) icon.textContent = '♥';
      btn.classList.add('wishlisted');
    }
  });

  updateWishlistHeaderCount();
});

